import _isPlainObject from 'lodash/isPlainObject'

const caseConverter = (object, conversionStrategy, recursive = false) => Object.keys(object).reduce((acc, key) => {
  let value = object[key]
  if (recursive) {
    if (_isPlainObject(value)) {
      value = caseConverter(value, conversionStrategy, recursive)
    } else if (Array.isArray(value) && value.every(_isPlainObject)) {
      value = value.map(v => caseConverter(v, conversionStrategy, recursive))
    }
  }
  acc[conversionStrategy(key)] = value
  return acc
}, {})

export default caseConverter
